import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
    AlertTriangle,
    Bell,
    CheckCircle,
    Lock,
    LogOut,
    Mail,
    Maximize2,
    MessageCircle,
    Search,
    Settings,
    User,
    UserPlus,
} from 'react-feather';
import { setTheme } from '../../utils/themes';
import logo from '../../assets/images/logo.png';
import MobileMenu from '../../layout/mobile/MobileMenu';

export default function Navbar() {
    const [togClass, setTogClass] = useState('dark');
    let theme = localStorage.getItem('theme');

    const darkMode = () => {
        if (localStorage.getItem('theme') === 'theme-dark') {
            setTheme('theme-light');
            setTogClass('light');
        } else {
            setTheme('theme-dark');
            setTogClass('dark');
        }
    };

    useEffect(() => {
        if (localStorage.getItem('theme') === 'theme-dark') {
            setTogClass('dark');
        } else if (localStorage.getItem('theme') === 'theme-light') {
            setTogClass('light');
        }
    }, [theme]);

    return (
        <>
            <div className='nav-navbar'>
                <div className='d-sm-block d-md-block d-lg-none d-xl-none d-xxl-none'>
                    <MobileMenu />
                </div>

                <div className='nav-right'>
                    <div
                        className='admin-avatar dropdown-toggle'
                        id='admin-avatar'
                        data-bs-toggle='dropdown'
                        aria-expanded='false'
                    >
                        <img
                            src='https://res.cloudinary.com/amirreza/image/upload/v1628080202/me_uzqd9m.jpg'
                            alt='امیررضا کدخدازاده'
                            title='امیررضا کدخدازاده'
                        />
                    </div>

                    <ul
                        className='dropdown-menu dropdown-menu-end'
                        aria-labelledby='admin-avatar'
                    >
                        <div className='dropdown-title ml-4 mt-2 mb-1'>
                            <p className='mb-0'>امیررضا کدخدازاده</p>

                            <p>
                                <small>iam@amirreza.dev</small>
                            </p>
                        </div>

                        <hr />

                        <li>
                            <Link className='dropdown-item' to='/'>
                                <User size={15} className='mr-3' />
                                مشاهده پروفایل
                            </Link>
                        </li>

                        <li>
                            <Link className='dropdown-item' to='/'>
                                <Maximize2 size={15} className='mr-3' />
                                تمام صفحه
                            </Link>
                        </li>

                        <li>
                            <Link className='dropdown-item' to='/'>
                                <Lock size={15} className='mr-3' />
                                قفل کردن صفحه
                            </Link>
                        </li>

                        <li>
                            <Link className='dropdown-item' to='/'>
                                <Settings size={15} className='mr-3' />
                                تنظیمات
                            </Link>
                        </li>

                        <li>
                            <Link className='dropdown-item' to='/auth/login'>
                                <LogOut size={15} className='mr-3' />
                                خروج
                            </Link>
                        </li>
                    </ul>

                    <div className='notifications'>
                        <Bell
                            className='dropdown-toggle Bell'
                            data-bs-toggle='dropdown'
                            aria-expanded='false'
                        />
                        <span className='pulse' />
                        <span className='pulse-ring' />

                        <div className='dropdown-menu dropdown-menu-end'>
                            <div className='dropdown-title'>
                                <div className='dropdown-content fw-bold'>
                                    شما 6 نوتیفیکیشن جدید دارید!
                                </div>
                            </div>

                            <hr />

                            <div className='dropdown-wrapper scrolled'>
                                <Link className='dropdown-item' to='/'>
                                    <div className='notify-icon bg-primary'>
                                        <Mail size={15} />
                                    </div>

                                    <p className='notify-details'>
                                        شما یک کامنت جدید دارید
                                        <small className='text-muted d-block'>
                                            1 دقیقه پیش
                                        </small>
                                    </p>
                                </Link>

                                <Link className='dropdown-item' to='/'>
                                    <div className='notify-icon bg-secondary'>
                                        <UserPlus size={15} />
                                    </div>

                                    <p className='notify-details'>
                                        یک نفر شما رو دنبال کرده
                                        <small className='text-muted d-block'>
                                            2 دقیقه پیش
                                        </small>
                                    </p>
                                </Link>

                                <Link className='dropdown-item' to='/'>
                                    <div className='notify-icon bg-success'>
                                        <CheckCircle size={15} />
                                    </div>

                                    <p className='notify-details'>
                                        محصول جدید اضافه شد
                                        <small className='text-muted d-block'>
                                            4 دقیقه پیش
                                        </small>
                                    </p>
                                </Link>

                                <Link className='dropdown-item' to='/'>
                                    <div className='notify-icon bg-danger'>
                                        <AlertTriangle size={15} />
                                    </div>

                                    <p className='notify-details'>
                                        خطایی در سرور رخ داده
                                        <small className='text-muted d-block'>
                                            10 دقیقه پیش
                                        </small>
                                    </p>
                                </Link>

                                <Link className='dropdown-item' to='/'>
                                    <div className='notify-icon bg-primary'>
                                        <Mail size={15} />
                                    </div>

                                    <p className='notify-details'>
                                        شما یک کامنت جدید دارید
                                        <small className='text-muted d-block'>
                                            2 ساعت پیش
                                        </small>
                                    </p>
                                </Link>

                                <Link className='dropdown-item' to='/'>
                                    <div className='notify-icon bg-secondary'>
                                        <UserPlus size={15} />
                                    </div>

                                    <p className='notify-details'>
                                        یک نفر شما رو دنبال کرده
                                        <small className='text-muted d-block'>
                                            2 ساعت پیش
                                        </small>
                                    </p>
                                </Link>

                                <Link className='dropdown-item' to='/'>
                                    <div className='notify-icon bg-success'>
                                        <CheckCircle size={15} />
                                    </div>

                                    <p className='notify-details'>
                                        محصول جدید اضافه شد
                                        <small className='text-muted d-block'>
                                            4 ساعت پیش
                                        </small>
                                    </p>
                                </Link>

                                <Link className='dropdown-item' to='/'>
                                    <div className='notify-icon bg-danger'>
                                        <AlertTriangle size={15} />
                                    </div>

                                    <p className='notify-details'>
                                        خطایی در سرور رخ داده
                                        <small className='text-muted d-block'>
                                            ۵ روز پیش
                                        </small>
                                    </p>
                                </Link>
                            </div>

                            <hr />

                            <div className='dropdown-title text-center mb-2'>
                                <a href='/'>مشاهده تمام پیام ها</a>
                            </div>
                        </div>
                    </div>

                    <div className='messages'>
                        <Mail
                            className='dropdown-toggle'
                            data-bs-toggle='dropdown'
                            aria-expanded='false'
                        />

                        <span className='messages-badge' />

                        <div className='dropdown-menu dropdown-menu-end'>
                            <div className='dropdown-title'>
                                <div className='dropdown-content fw-bold'>
                                    شما 5 پیام جدید دارید!
                                </div>
                            </div>

                            <hr />

                            <div className='dropdown-wrapper scrolled'>
                                <Link className='dropdown-item' to='/'>
                                    <div className='notify-icon bg-primary'>
                                        <Mail size={15} />
                                    </div>

                                    <p className='notify-details'>
                                        شما یک ایمیل جدید دارید
                                        <small className='text-muted d-block'>
                                            1 دقیقه پیش
                                        </small>
                                    </p>
                                </Link>

                                <Link className='dropdown-item' to='/'>
                                    <div className='notify-icon bg-success'>
                                        <MessageCircle size={15} />
                                    </div>

                                    <p className='notify-details'>
                                        شما یک پیام جدید دارید
                                        <small className='text-muted d-block'>
                                            2 ساعت پیش
                                        </small>
                                    </p>
                                </Link>

                                <Link className='dropdown-item' to='/'>
                                    <div className='notify-icon bg-primary'>
                                        <Mail size={15} />
                                    </div>

                                    <p className='notify-details'>
                                        شما یک ایمیل جدید دارید
                                        <small className='text-muted d-block'>
                                            2 ساعت پیش
                                        </small>
                                    </p>
                                </Link>

                                <Link className='dropdown-item' to='/'>
                                    <div className='notify-icon bg-success'>
                                        <MessageCircle size={15} />
                                    </div>

                                    <p className='notify-details'>
                                        شما یک پیام جدید دارید
                                        <small className='text-muted d-block'>
                                            2 ساعت پیش
                                        </small>
                                    </p>
                                </Link>
                            </div>
                        </div>
                    </div>

                    <div className='dark-mode mt-2'>
                        {togClass === 'light' ? (
                            <input
                                type='checkbox'
                                name='mode'
                                id='toggle'
                                value=''
                                onClick={darkMode}
                                defaultChecked
                            />
                        ) : (
                            <input
                                type='checkbox'
                                name='mode'
                                id='toggle'
                                value=''
                                onClick={darkMode}
                            />
                        )}
                        <label htmlFor='toggle' />
                    </div>
                </div>

                <div className='nav-center d-none d-lg-block d-xl-block d-xxl-block'>
                    <form>
                        <div className='search'>
                            <input placeholder='جستجو...' />

                            <span className='search-icon'>
                                <Search />
                            </span>
                        </div>
                    </form>
                </div>

                <div className='nav-left d-none d-lg-block d-xl-block d-xxl-block'>
                    <Link to='/'>
                        <img
                            src={logo}
                            alt='داشبورد شاپینکس'
                            title='داشبورد شاپینکس'
                            className='logo'
                        />
                    </Link>
                </div>
            </div>
        </>
    );
}
